module.exports = __webpack_public_path__ + "img/laodl_dealer_digital3.7ad103f6.jpg";